module.exports = __webpack_public_path__ + "static/media/YF82_0.4340f435.jpg";